import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import cytoscape from 'cytoscape';
import newDataJson from 'src/app/newData.json';
import d3Force from 'cytoscape-d3-force';
d3Force(cytoscape);

import dblclick from 'cytoscape-dblclick';
cytoscape.use(dblclick);

import contextMenus from 'cytoscape-context-menus';
cytoscape.use(contextMenus);

import { nodiEntrantiIponimiaService } from 'src/app/funzioniCtxMenu/ApriNodiEntranti/nodiEntrantiIponimia.service';
import { nodiEntrantiMeronimiaService } from './funzioniCtxMenu/ApriNodiEntranti/nodiEntrantiMeronimia.service';
import { nodiEntrantiSinonimiaservice } from './funzioniCtxMenu/ApriNodiEntranti/nodiEntrantiSinonimia.service';
import { nodiUscentiIponimiaService } from './funzioniCtxMenu/ApriNodiUscenti/nodiUscentiIpo.service';
import { nodiUscentiMeronimiaService } from './funzioniCtxMenu/ApriNodiUscenti/nodiUscentiMeronimia.service';
import { nodiUscentiSinonimiaService } from './funzioniCtxMenu/ApriNodiUscenti/nodiUscentiSinonimia.service';
import { tuttiNodiIponimiaService } from './funzioniCtxMenu/ApriTuttiNodi/tuttiNodiIponimia.service';
import { tuttiNodiMeronimiaService } from './funzioniCtxMenu/ApriTuttiNodi/tuttiNodiMeronimia.service';
import { tuttiNodiSinonimiaService } from './funzioniCtxMenu/ApriTuttiNodi/tuttiNodiSinonimia.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', './mediaquerie.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    nodiEntrantiIponimiaService,
    nodiEntrantiMeronimiaService,
    nodiEntrantiSinonimiaservice,
    nodiUscentiIponimiaService,
    nodiUscentiMeronimiaService,
    nodiUscentiSinonimiaService,
    tuttiNodiIponimiaService,
    tuttiNodiMeronimiaService,
    tuttiNodiSinonimiaService]
})


export class AppComponent {


  constructor(
    private nodiEntrantiIpo: nodiEntrantiIponimiaService,
    private nodiEntrantiMero: nodiEntrantiMeronimiaService,
    private nodiEntrantiSino: nodiEntrantiSinonimiaservice,
    private nodiUscentiIpo: nodiUscentiIponimiaService,
    private nodiUscentiMero: nodiUscentiMeronimiaService,
    private nodiUscentiSino: nodiUscentiSinonimiaService,
    private tuttiNodiIpo: tuttiNodiIponimiaService,
    private tuttiNodiMero: tuttiNodiMeronimiaService,
    private tuttiNodiSino: tuttiNodiSinonimiaService
  ) { }

  title = 'provaCytoscape';
  // account: Account | null = null;
  cy: any;


  ctxMenu; //variabile context menu
  contextMenu; //variabile context menu

  isDisplay: boolean = false;
  divInfo: boolean = false;
  selezione;
  nodoS;
  condition: boolean = false;
  nodoCliccato: any;
  nodiSelezionati: any[] = [];


  idPersonal: string;
  currentEle: string;

  linkD: number = 150;
  linkStep: number = 100;
  layoutProva;
  eleStyle: any;

  zoomStep: number = 0.1;
  zoomCurrent: number = 1;

  iponimiaB: boolean = true;
  meronimiaB: boolean = false;

  zoomNodoForm: FormGroup;
  trattato;
  searchText = '';
  // trattati: Trattato[];
  trattati: any[];
  close: boolean;
  closeD: boolean;
  removedData;
  clicked: boolean = false;
  layoutNodoClicked;
  focusNode: string;
  relazioneIponimia: boolean = false;
  relazioneMeronimia: boolean = false;
  relazioneSinonimia: boolean = false;

  ngOnInit(): void {
    const that = this; //toglie errore undefined 
    //filtro su array graph json 
    this.trattati = newDataJson[0].nodes.map(el => {
      return el.data.id;
    })

    // array ordine alfabetico
    this.trattati = newDataJson[0].nodes.sort(function (a, b) {
      var nameA = a.data.label.toUpperCase(); // ignore upper and lowercase
      var nameB = b.data.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });


    this.trattati = newDataJson[0].nodes.filter(el => {
      return el.data.id;
    })


    this.zoomNodoForm = new FormGroup({
      'idPersonal': new FormControl(null)
    });

    this.cy = cytoscape({
      container: document.getElementById('cy'),
      elements: newDataJson[0],
      minZoom: 0.2,
      maxZoom: 5.0,
      zoomingEnabled: true,
      // userZoomingEnabled: true,
      zoom: this.zoomCurrent,
      textureOnViewport: true,
      hideEdgesOnViewport: true,
      style: [
        {
          selector: 'node',
          style: {
            'label': 'data(label)',
            'text-margin-y': 5,
            'display': 'none',
            'width': '50',
            'height': '50',
            'text-halign': 'center',
            'text-valign': 'bottom',
            'font-size': 13
          }
        },
        {
          selector: 'node.2livello',
          style: {
            'opacity': 0
          }
        },
        {
          selector: 'node.nascondi',
          style: {
            'display': 'none'
          }
        },
        {
          selector: 'node.highlightOpen',
          style: {
            // 'border-color': '#ffff00',
            // 'border-width': '6px',
            // 'z-index': 2,
            'overlay-color': '#e6e6e6',
            'overlay-opacity': 0.5,
            'overlay-padding': '2px'
          }
        },
        {
          selector: 'node.select',
          style: {
            'background-color': '#0099ff'
          }
        },
        {
          selector: 'node.iponimia',
          style: {
            'background-color': '#02768C'
          }
        },
        {
          selector: 'node.iponimiaDBClick',
          style: {
            'background-color': '#b8eaf2' 
          }
        },
        {
          selector: 'node.meronimia',
          style: {
            'background-color': '#E49D00'
          }
        },
        {
          selector: 'node.meronimiaDBClick',
          style: {
            'background-color': '#f7dfaf' 
          }
        },
        {
          selector: 'node.sinonimia',
          style: {
            'background-color': '#720040'
          }
        },
        {
          selector: 'node.sinonimiaDBClick',
          style: {
            'background-color': '#eab4d3'
          }
        },
        {
          selector: 'node.grey',
          style: {
            'background-color': 'grey'
          }
        },
        {
          selector: 'edge',
          style: {
            'target-arrow-shape': 'triangle',
            'curve-style': 'straight',
            'display': 'none'
          }
        },
        {
          selector: 'edge.2livello',
          style: {
            'opacity': 0
          }
        },
        {
          selector: 'edge.edges',
          style: {
            'line-color': "#e0e0d2",
            'target-arrow-color': '#e0e0d2',
            'line-style': 'solid'
          },
        },
        {
          selector: 'edge.highlight',
          style: {
            'line-color': '#ffff00',
            'target-arrow-color': '#ffff00'
          }
        }
      ],
    });

    this.cy.center();

    // estensione dbclick
    this.cy.dblclick();

    // permette all'utente di spostare l'intero grafo con il mouse
    this.cy.userPanningEnabled(true);

    // estensione context menu
    this.ctxMenu = {
      evtType: 'cxttap',
      menuItems: [
        {
          id: 'apriNodiEntranti',
          content: 'apri nodi entranti',
          tooltipText: 'apri nodi entranti',
          selector: 'node',
          onClickFunction: function (event) {
            let nodoDBClick = event.target;
            let nodoDBincomers = event.target.incomers();
            sessionStorage.getItem('focusNode');

            var incomersIponimia = event.target.incomers('edge[relationType = "hyponym"]');
            var outgoersIponimia = event.target.outgoers('edge[relationType = "hyponym"]');
            var incomersMeronimia = event.target.incomers('edge[relationType = "partMeronym"]');
            var outgoersMeronimia = event.target.outgoers('edge[relationType = "partMeronym"]');
            var incomersSinonimia = event.target.incomers('edge[relationType = "synonym"]');
            var outgoersSinonimia = event.target.outgoers('edge[relationType = "synonym"]')
            var elemSessionStorage = that.cy.getElementById(sessionStorage.getItem('focusNode'));

            nodoDBincomers.addClass("edges");
            // controllo se il tipo di relazione è iponimia
            if ((that.relazioneIponimia === true) && (that.relazioneMeronimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.nodiEntrantiIpo.nodiEntrantiIponimia(event); //servizio nodi entranti iponimia   
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if (elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                iponimiIncomers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 200) {
                // nodi > 200
                var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                    h: 200, w: 200
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                iponimiIncomers.run();
                that.cy.fit(':visible');
              } else {
                // nodi < 20
                elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc + 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                })
              }
              nodoDBincomers.sources().removeClass("iponimiaDBClick");
              nodoDBincomers.sources().addClass("iponimia");
              nodoDBincomers.addClass("edges");
              nodoDBClick.addClass("iponimiaDBClick");
              // controllo se il tipo di relazione è meronimia
            } else if ((that.relazioneMeronimia === true) && (that.relazioneIponimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.nodiEntrantiMero.nodiEntrantiMeronimia(event); //servizio nodi entranti meronimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                meronimiIncomers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 200) {
                //nodi > 200
                var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                    h: 200, w: 200
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                meronimiIncomers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length < 20) {
                //nodi < 20
                elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc + 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
                that.cy.fit(':visible');
              }
              nodoDBincomers.sources().removeClass("meronimiaDBClick");
              nodoDBincomers.sources().addClass("meronimia");
              nodoDBincomers.addClass("edges");
              nodoDBClick.removeClass("sinonimiaDBClick");
              nodoDBClick.addClass("meronimiaDBClick");
            }
            // controllo se il tipo di relazione è sinonimia
            else {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              that.nodiEntrantiSino.nodiEntrantiSinonimia(event); // servizio nodi entranti sinonimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if (elemSessionStorage.incomers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                sinonimiIncomers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
                //nodi > 200
                var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                    h: 200, w: 200
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                sinonimiIncomers.run();
                that.cy.fit(':visible');
              } else {
                //nodi < 20
                elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc + 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
              }
              nodoDBincomers.sources().removeClass("sinonimiaDBClick");
              nodoDBincomers.sources().addClass("sinonimia");
              // tolgo freccia negli edge della sinonimia
              nodoDBincomers.style("target-arrow-shape", 'none');
              nodoDBincomers.addClass("edges");
              nodoDBClick.addClass("sinonimiaDBClick");
            }
            if (nodoDBincomers.sources().toArray().length > 4) {
              that.cy.fit(':visible');
            }
          },
          disabled: false
        },
        {
          id: 'apriNodiUscenti',
          content: 'apri nodi uscenti',
          tooltipText: 'apri nodi uscenti',
          selector: 'node,',
          onClickFunction: function (event) {
            let nodoDBClick = event.target;
            let nodoDBoutgoers = event.target.outgoers();
            sessionStorage.getItem('focusNode');
            var incomersIponimia = event.target.incomers('edge[relationType = "hyponym"]');
            var outgoersIponimia = event.target.outgoers('edge[relationType = "hyponym"]');
            var incomersMeronimia = event.target.incomers('edge[relationType = "partMeronym"]');
            var outgoersMeronimia = event.target.outgoers('edge[relationType = "partMeronym"]');
            var incomersSinonimia = event.target.incomers('edge[relationType = "synonym"]');
            var outgoersSinonimia = event.target.outgoers('edge[relationType = "synonym"]')
            var elemSessionStorage = that.cy.getElementById(sessionStorage.getItem('focusNode'));
            // controllo se il tipo di relazione è iponimia
            if ((that.relazioneIponimia === true) && (that.relazioneMeronimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.nodiUscentiIpo.nodiUscentiIponimia(event); //servizio nodi uscenti iponimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if (elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                iponimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
                //nodi > 200
                var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                    h: 200, w: 100
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                iponimiOutgoers.run();
                that.cy.fit(':visible');
              } else {
                //nodi > 20
                elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc - 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
              }
              nodoDBoutgoers.targets().removeClass("iponimiaDBClick");
              nodoDBoutgoers.targets().addClass("iponimia");
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.addClass("iponimiaDBClick");
              // controllo se il tipo di relazione è meronimia
            } else if ((that.relazioneMeronimia === true) && (that.relazioneIponimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.nodiUscentiMero.nodiUscentiMeronimia(event); //servizio nodi uscenti meronimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if (elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                meronimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length > 200) {
              //nodi > 200
                var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                    h: 200, w: 100
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                meronimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length < 20) {
                //nodi < 20
                elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc - 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
              }
              nodoDBoutgoers.targets().removeClass("meronimiaDBClick");
              nodoDBoutgoers.targets().addClass("meronimia");
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.removeClass("sinonimiaDBClick");
              nodoDBClick.addClass("meronimiaDBClick");
            }
            // controllo se il tipo di relazione è sinonimia
            else {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              that.nodiUscentiSino.nodiUscentiSinonimia(event); //servizio nodi uscenti sinonimia
                // POSIZIONI NODI PRE FUNZIONE DB CLIC
                if (elemSessionStorage.outgoers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200) {
                //nodi tra 20 e 200
                  sinonimiOutgoers.run();
                  that.cy.fit(':visible');
                } else if (elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
                  //nodi > 200
                  var sinonimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().layout({
                    name: "grid", fit: true, boundingBox: {
                      x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                      h: 200, w: 100
                    }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                  });
                  sinonimiOutgoers.run();
                  that.cy.fit(':visible');
                  //nodi < 20
                } else {
                  console.log("SINONIMIA PRE DOUBLE CLIC nodi < 20");
                  elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().positions(function (nodi, i) {
                    var xc = elemSessionStorage.position('x');
                    var yc = elemSessionStorage.position('y');
                    var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                    var yRet = yc - 75;
                    return {
                      x: xRet,
                      y: yRet
                    };
                  });
                }
              nodoDBoutgoers.targets().removeClass("sinonimiaDBClick");
              nodoDBoutgoers.targets().addClass("sinonimia");
              // tolgo freccia negli edge della sinonimia
              nodoDBoutgoers.style("target-arrow-shape", 'none');
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.addClass("sinonimiaDBClick");
            }
            if (nodoDBoutgoers.targets().toArray().length > 4) {
              that.cy.fit(':visible');
            }
          },
          disabled: false
        },
        {
          id: 'apriTuttiNodi',
          content: 'apri tutti i nodi',
          tooltipText: 'apri tutti nodi',
          selector: 'node',
          onClickFunction: function (event) {
            let nodoDBClick = event.target;
            let nodoDBincomers = event.target.incomers();
            let nodoDBoutgoers = event.target.outgoers();
            sessionStorage.getItem('focusNode');
            var incomersIponimia = event.target.incomers('edge[relationType = "hyponym"]');
            var outgoersIponimia = event.target.outgoers('edge[relationType = "hyponym"]');
            var incomersMeronimia = event.target.incomers('edge[relationType = "partMeronym"]');
            var outgoersMeronimia = event.target.outgoers('edge[relationType = "partMeronym"]');
            var incomersSinonimia = event.target.incomers('edge[relationType = "synonym"]');
            var outgoersSinonimia = event.target.outgoers('edge[relationType = "synonym"]')
            var elemSessionStorage = that.cy.getElementById(sessionStorage.getItem('focusNode'));
            nodoDBincomers.addClass("edges");
            nodoDBoutgoers.addClass("edges");
            // controllo se il tipo di relazione è iponimia
            if ((that.relazioneIponimia === true) && (that.relazioneMeronimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.tuttiNodiIpo.tuttiNodiIponimia(event); //servizio apri tutti nodi iponimia
               // POSIZIONI NODI PRE FUNZIONE DB CLIC
               if ((elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200
               || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200)) {
               //nodi tra 20 e 200
               var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
                 name: "grid", fit: true, boundingBox: {
                   x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                   h: 50, w: 50
                 }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
               });
               var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
                 name: "grid", fit: true, boundingBox: {
                   x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
                   h: 50, w: 50
                 }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
               });
               iponimiIncomers.run();
               iponimiOutgoers.run();
               that.cy.fit(':visible');
             } else if (elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
              //nodi > 200
               var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
                 name: "grid", fit: true, boundingBox: {
                   x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                   h: 200, w: 200
                 }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
               });
               var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
                 name: "grid", fit: true, boundingBox: {
                   x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                   h: 200, w: 100
                 }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
               });
               iponimiIncomers.run();
               iponimiOutgoers.run();
               that.cy.fit(':visible');
             } else {
               //nodi > 20
               elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().positions(function (nodi, i) {
                 var xc = elemSessionStorage.position('x');
                 var yc = elemSessionStorage.position('y');
                 var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                 var yRet = yc + 75;
                 return {
                   x: xRet,
                   y: yRet
                 };
               });
               elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().positions(function (nodi, i) {
                 var xc = elemSessionStorage.position('x');
                 var yc = elemSessionStorage.position('y');
                 var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                 var yRet = yc - 75;
                 return {
                   x: xRet,
                   y: yRet
                 };
               });
             }
              nodoDBincomers.sources().removeClass("iponimiaDBClick");
              nodoDBoutgoers.targets().removeClass("iponimiaDBClick");
              nodoDBincomers.sources().addClass("iponimia");
              nodoDBoutgoers.targets().addClass("iponimia");
              nodoDBincomers.addClass("edges");
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.addClass("iponimiaDBClick");
              // controllo se il tipo di relazione è meronimia
            } else if ((that.relazioneMeronimia === true) && (that.relazioneIponimia === false) && (that.relazioneSinonimia === false)) {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersSinonimia.sources().style("visibility", "hidden");
              outgoersSinonimia.targets().style("visibility", "hidden");
              incomersSinonimia.style("visibility", "hidden");
              outgoersSinonimia.style("visibility", "hidden");
              that.tuttiNodiMero.tuttiNodiMeronimia(event); //servizio apri tutti nodi meronimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if ((elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length < 200
                || elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length < 200)) {
                //nodi tra 20 e 200
                var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                meronimiIncomers.run();
                meronimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length > 200) {
                //nodi > 200
                var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                    h: 200, w: 200
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                    h: 200, w: 100
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                meronimiIncomers.run();
                meronimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length < 20 || elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length < 20) {
                //nodi > 20
                elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc + 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
                elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc - 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
              }
              nodoDBincomers.sources().removeClass("meronimiaDBClick");
              nodoDBoutgoers.targets().removeClass("meronimiaDBClick");
              nodoDBincomers.sources().addClass("meronimia");
              nodoDBoutgoers.targets().addClass("meronimia");
              nodoDBincomers.addClass("edges");
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.removeClass("sinonimiaDBClick");
              nodoDBClick.addClass("meronimiaDBClick");
            }
            // controllo se il tipo di relazione è sinonimia
            else {
              sessionStorage.setItem('focusNode', event.target.data().id);
              // nodi da nascondere
              incomersIponimia.sources().style("visibility", "hidden");
              outgoersIponimia.targets().style("visibility", "hidden");
              incomersIponimia.style("visibility", "hidden");
              outgoersIponimia.style("visibility", "hidden");
              incomersMeronimia.sources().style("visibility", "hidden");
              outgoersMeronimia.targets().style("visibility", "hidden");
              incomersMeronimia.style("visibility", "hidden");
              outgoersMeronimia.style("visibility", "hidden");
              that.tuttiNodiSino.tuttiNodiSinonimia(event); //servizio apri tutti nodi sinonimia
              // POSIZIONI NODI PRE FUNZIONE DB CLIC
              if ((elemSessionStorage.incomers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200
                || elemSessionStorage.outgoers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200)) {
                //nodi tra 20 e 200
                var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                var sinonimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
                    h: 50, w: 50
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
                });
                sinonimiIncomers.run();
                sinonimiOutgoers.run();
                that.cy.fit(':visible');
              } else if (elemSessionStorage.incomers('edge[relationType = "synonym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
                //nodi > 200
                var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
                    h: 200, w: 200
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                var sinonimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().layout({
                  name: "grid", fit: true, boundingBox: {
                    x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
                    h: 200, w: 100
                  }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
                });
                sinonimiIncomers.run();
                sinonimiOutgoers.run();
                that.cy.fit(':visible');
              } else {
                //nodi > 20 
                elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc + 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
                elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().positions(function (nodi, i) {
                  var xc = elemSessionStorage.position('x');
                  var yc = elemSessionStorage.position('y');
                  var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                  var yRet = yc - 75;
                  return {
                    x: xRet,
                    y: yRet
                  };
                });
               }
              nodoDBincomers.sources().removeClass("sinonimiaDBClick");
              nodoDBoutgoers.targets().removeClass("sinonimiaDBClick");
              nodoDBincomers.sources().addClass("sinonimia");
              nodoDBoutgoers.targets().addClass("sinonimia");
              // tolgo freccia negli edge della sinonimia
              nodoDBincomers.style("target-arrow-shape", 'none');
              nodoDBoutgoers.style("target-arrow-shape", 'none');
              nodoDBincomers.addClass("edges");
              nodoDBoutgoers.addClass("edges");
              nodoDBClick.addClass("sinonimiaDBClick");
            }
            if (nodoDBincomers.sources().toArray().length > 4 || nodoDBoutgoers.targets().toArray().length > 4) {
              that.cy.fit(':visible');
            }
          },
          disabled: false
        },
        {
          id: 'chiudiNodo',
          content: 'rimuovi nodo',
          tooltipText: 'rimuovi nodo',
          selector: 'node',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            target.style("display", "none");
            that.nodiSelezionati = [];
          },
          disabled: false
        },
        {
          id: 'chiudiNodi',
          content: 'chiudi tutti i nodi',
          tooltipText: 'chiudi tutti i nodi',
          selector: 'node',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            target.outgoers().style("display", "none");
            target.incomers().style("display", "none");
          },
          disabled: false
        },
        {
          id: 'chiudiNodiEntranti',
          content: 'chiudi nodi entranti',
          tooltipText: 'chiudi nodi entranti',
          selector: 'node',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            target.incomers().style("display", "none");
          },
          disabled: false
        },
        {
          id: 'chiudiNodiUscenti',
          content: 'chiudi nodi uscenti',
          tooltipText: 'chiudi nodi uscenti',
          selector: 'node, edge',
          onClickFunction: function (event) {
            sessionStorage.setItem('focusNode', event.target.data().id);
            let target = event.target;
            target.outgoers().style("display", "none");
          },
          disabled: false
        },
      ],
    };
    this.contextMenu = this.cy.contextMenus(this.ctxMenu);

    // funzione espandi/nascondi nodi  
    this.cy.on('dblclick', 'node', function (event) {
      let nodoDBClick = event.target;
      let nodoDBincomers = event.target.incomers();
      let nodoDBoutgoers = event.target.outgoers();

      // iponimi
      var iponimoIncomers = event.target.incomers().filter('edge[relationType = "hyponym"]');
      var iponimoOutgoers = event.target.outgoers().filter('edge[relationType = "hyponym"]');
      // meronimi
      var meronimoIncomers = event.target.incomers().filter('edge[relationType = "partMeronym"]');
      var meronimoOutgoers = event.target.outgoers().filter('edge[relationType = "partMeronym"]');
      // sinonimi
      var sinonimoIncomers = event.target.incomers().filter('edge[relationType = "synonym"]');
      var sinonimoOutgoers = event.target.outgoers().filter('edge[relationType = "synonym"]');
      nodoDBClick.removeClass("select");
      // se nodi entranti e uscenti nono sono visibili aprili
      if (nodoDBincomers.style("display") == "none" || nodoDBoutgoers.style("display") == "none") {
        nodoDBincomers.style("display", "element");
        nodoDBoutgoers.style("display", "element");
        // istruzioni per colorare nodi e archi di secondo livello in grigio
        // incomers classe iponimia
        nodoDBincomers.sources().predecessors().sources().removeClass("iponimia");
        nodoDBincomers.sources().successors().targets().removeClass("iponimia");
        nodoDBincomers.sources().predecessors().sources().removeClass("iponimiaDBClick");
        nodoDBincomers.sources().successors().targets().removeClass("iponimiaDBClick");
        // incomers classe meronimia
        nodoDBincomers.sources().predecessors().sources().removeClass("meronimia");
        nodoDBincomers.sources().successors().targets().removeClass("meronimia");
        nodoDBincomers.sources().predecessors().sources().removeClass("meronimiaDBClick");
        nodoDBincomers.sources().successors().targets().removeClass("meronimiaDBClick");
        // incomers classe sinonimia
        nodoDBincomers.sources().predecessors().sources().removeClass("sinonimia");
        nodoDBincomers.sources().successors().targets().removeClass("sinonimia");
        nodoDBincomers.sources().predecessors().sources().removeClass("sinonimiaDBClick");
        nodoDBincomers.sources().successors().targets().removeClass("sinonimiaDBClick");
        nodoDBincomers.sources().predecessors().removeClass("edges");
        nodoDBincomers.sources().successors().removeClass("edges");
        // outgoers classe iponimia
        nodoDBoutgoers.targets().successors().targets().removeClass("iponimia");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("iponimia");
        nodoDBoutgoers.targets().successors().targets().removeClass("iponimiaDBClick");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("iponimiaDBClick");
        nodoDBoutgoers.successors().removeClass("edges");
        nodoDBoutgoers.predecessors().removeClass("edges");
        // outgoers classe meronimia
        nodoDBoutgoers.targets().successors().targets().removeClass("meronimia");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("meronimia");
        nodoDBoutgoers.targets().successors().targets().removeClass("meronimiaDBClick");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("meronimiaDBClick");
        // outgoers classe sinonimia
        nodoDBoutgoers.targets().successors().targets().removeClass("sinonimia");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("sinonimia");
        nodoDBoutgoers.targets().successors().targets().removeClass("sinonimiaDBClick");
        nodoDBoutgoers.targets().predecessors().sources().removeClass("sinonimiaDBClick");
        //1 CASO nodi tra 20 e 200
        if ((iponimoIncomers.toArray().length > 20 && iponimoIncomers.toArray().length < 200
          || iponimoOutgoers.toArray().length > 20 && iponimoOutgoers.toArray().length < 200) ||
          (meronimoIncomers.toArray().length > 20 && meronimoIncomers.toArray().length < 200
            || meronimoOutgoers.toArray().length > 20 && meronimoOutgoers.toArray().length < 200) ||
          (sinonimoIncomers.toArray().length > 20 && sinonimoIncomers.toArray().length < 200
            || sinonimoOutgoers.targets().toArray().length > 20 && sinonimoOutgoers.targets().toArray().length < 200)) {
          // nodi in grigio se il numero nodi predecessori entranti/uscenti è > 20 
          if (nodoDBincomers.sources().predecessors().sources().toArray().length > 20 || nodoDBincomers.sources().successors().targets().toArray().length > 20
            && nodoDBoutgoers.targets().successors().targets().toArray().length > 20 || nodoDBoutgoers.targets().predecessors().sources().toArray().length > 20) {
            // nodes
            nodoDBincomers.sources().predecessors().sources().addClass("2livello");
            nodoDBincomers.sources().successors().targets().addClass("2livello");
            nodoDBoutgoers.targets().successors().targets().addClass("2livello");
            nodoDBoutgoers.targets().predecessors().sources().addClass("2livello");
            // edges
            nodoDBincomers.predecessors().addClass("2livello");
            nodoDBincomers.successors().addClass("2livello");
            nodoDBoutgoers.successors().addClass("2livello");
            nodoDBoutgoers.predecessors().addClass("2livello");
            nodoDBClick.removeClass("2livello");
            nodoDBincomers.sources().removeClass("2livello");
            nodoDBincomers.removeClass("2livello");
            nodoDBoutgoers.targets().removeClass("2livello");
            nodoDBoutgoers.removeClass("2livello");
          }
        } else if ( 
          // 2 CASO nodi > 200
          (iponimoIncomers.toArray().length > 200 || iponimoOutgoers.toArray().length > 200) ||
          (meronimoIncomers.toArray().length > 200 || meronimoOutgoers.toArray().length > 200) ||
          (sinonimoIncomers.toArray().length > 200 || sinonimoOutgoers.toArray().length > 200)) {
            // nodi in grigio se il numero nodi predecessori entranti/uscenti è > 20 
          if (nodoDBincomers.sources().incomers().sources().toArray().length > 20 || nodoDBincomers.sources().outgoers().targets().toArray().length > 20
            && nodoDBoutgoers.targets().outgoers().targets().toArray().length > 20 || nodoDBoutgoers.targets().incomers().sources().toArray().length > 20) {
            // nodes
            nodoDBincomers.sources().predecessors().sources().addClass("2livello");
            nodoDBincomers.sources().successors().targets().addClass("2livello");
            nodoDBoutgoers.targets().successors().targets().addClass("2livello");
            nodoDBoutgoers.targets().predecessors().sources().addClass("2livello");
            // edges
            nodoDBincomers.predecessors().addClass("2livello");
            nodoDBincomers.successors().addClass("2livello");
            nodoDBoutgoers.successors().addClass("2livello");
            nodoDBoutgoers.predecessors().addClass("2livello");
            nodoDBClick.removeClass("2livello");
            nodoDBincomers.sources().removeClass("2livello");
            nodoDBincomers.removeClass("2livello");
            nodoDBoutgoers.targets().removeClass("2livello");
            nodoDBoutgoers.removeClass("2livello");
          }
        } else {
          // nodi < 20 
          nodoDBClick.removeClass("2livello");
          nodoDBincomers.sources().removeClass("2livello");
          nodoDBincomers.removeClass("2livello");
          nodoDBoutgoers.targets().removeClass("2livello");
          nodoDBoutgoers.removeClass("2livello");
        }
      } else { 
        // nascondo nodi
        nodoDBincomers.style("display", "none");
        nodoDBoutgoers.style("display", "none");
        nodoDBincomers.sources().incomers().style("display", "none");
        nodoDBoutgoers.targets().outgoers().style("display", "none");
        nodoDBClick.style("display", "element");
      }
    });


    // recupero info nodo al clic sul nodo di interesse
    this.cy.on('click', 'node', function (evt) {
      const panel = document.getElementById('panel');
      const pannello = document.getElementById('pannello');
      const node = evt.target;
      // iponimia
      let iponimiincomers = evt.target.incomers('edge[relationType = "hyponym"]').sources().toArray().length;;
      let iponimioutgoers = evt.target.outgoers('edge[relationType = "hyponym"]').targets().toArray().length;;
      // meronimia
      let meronimiincomers = evt.target.incomers('edge[relationType = "partMeronym"]').sources().toArray().length;
      let meronimioutgoers = evt.target.outgoers('edge[relationType = "partMeronym"]').targets().toArray().length;
      // sinonimia DA CONTROLLARE
      let sinonimoincomers = evt.target.incomers('edge[relationType = "synonym"]').sources().toArray().length;
      let sinonimooutgoers = evt.target.outgoers('edge[relationType = "synonym"]').targets().toArray().length;
      // let sinonimi = (sinonimoincomers + sinonimooutgoers);
      // let sinonimi = evt.target.connectedEdges('edge[relationType = "synonym"]').toArray().length;
      // let sinonimi = evt.target.connectedEdges('edge[relationType = "synonym"]').toArray().length;

      if (this.currentEle !== node.data()) {   //se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
        this.currentEle = node.data();
        node.flashClass("highlightOpen", 2000);
        panel.innerHTML = `<p><b>ID</b> : ${this.currentEle.id} </p> <p><b>LABEL</b> : ${this.currentEle.label} </p>
        <p><b>DEFINITION</b> : ${this.currentEle.definition} </p><p><b>POS</b> : ${this.currentEle.pos} </p>
        <p><b>IRI</b> : ${this.currentEle.iri} </p> <p><b>N° IPONIMI</b> : ${iponimiincomers} </p> <p><b>N° IPERONIMI</b> : ${iponimioutgoers}</p>
        <p><b>N° MERONIMI</b> : ${meronimiincomers} </p> <p><b>N° OLONIMI</b> : ${meronimioutgoers}</p>
        <p><b>N° REL. SINONIMICHE ENTRANTI </b> : ${sinonimoincomers}</p><p><b>N° REL. SINONIMICHE USCENTI </b> : ${sinonimooutgoers}</p> `; //stringhe con variabili all'interno, quello inserito tra $ e par graffa deve essere variabile o espressione ecc.
        panel.style.display = 'block';
        pannello.style.display = 'block';
      } else {
        panel.style.display = 'none';
        pannello.style.display = 'none';
        this.currentEle = null; //resetto il valore 
      }
    });
    // chiudo panel se clicco su background
    this.cy.on('tap', function (evt) {
      const node = evt.target;
      const panel = document.getElementById('panel');
      if (node === this) { //this è il core
        console.log('tap on cy');
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        }
      }
    });

    //  recupero info edge al clic sull'edge di interesse
    this.cy.on('tap', 'edge', function (evt) {
      const pannello = document.getElementById('pannello');
      const panel = document.getElementById('panel');
      const node = evt.target;
      if (this.currentEle !== node.data()) {   //se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
        this.currentEle = node.data();
        node.flashClass("highlight", 2000);
        panel.innerHTML = `<p><b>ID</b> : ${this.currentEle.id} </p><p><b>SOURCE</b> : ${this.currentEle.source} </p>
        <p><b>TARGET</b> : ${this.currentEle.target} </p><p><b>LABEL SOURCE</b> : ${this.currentEle.labelSource} </p>
        <p><b>LABEL TARGET</b> : ${this.currentEle.labelTarget} </p><p><b>RELATION TYPE</b> : ${this.currentEle.relationType} </p>`; //stringhe con variabili all'interno, quello inserito tra $ e par graffa deve essere variabile o espressione ecc.
        panel.style.display = 'block';
        pannello.style.display = 'block';
      } else {
        panel.style.display = 'none';
        pannello.style.display = 'none';
        this.currentEle = null; //resetto il valore 
      }
    });

  }

  public trackByIndex(index: number, value: any) {
    return index;
  }

  cliccato(trat) {
    // recupero valore nodo cliccato e lo salvo nel local storage(memoria locale)
    sessionStorage.setItem('focusNode', trat.data.id);
    console.log(' funzione cliccato session storage ' + sessionStorage.getItem('focusNode'));
    this.cy.getElementById(sessionStorage.getItem('focusNode')).style('visibility','visible');
    this.nodiSelezionati.pop();
    this.clicked = false;
    var elemento = this.cy.getElementById(trat.data.id);
    // mostro solo nodo cliccato dalla lista laterale
    if (this.cy.elements(':visible')) {
      this.cy.elements().style("display", "none");
    }
    elemento.style('display', 'element');
    elemento.removeClass("selected");
    elemento.removeClass("2livello");
    elemento.connectedEdges().removeClass("2livello");
    // il nodo selezionato dalla lista prende il colore della relazione scelta
    if ((this.relazioneIponimia === true) && (this.relazioneMeronimia === false) && (this.relazioneSinonimia === false)){
      elemento.addClass('iponimiaDBClick');
    } else if(((this.relazioneMeronimia === true) && (this.relazioneIponimia === false) && (this.relazioneSinonimia === false))){
      elemento.addClass('meronimiaDBClick');
    } else {
      elemento.addClass('sinonimiaDBClick');
    }
    this.nodoCliccato = trat.data.id;
    this.nodiSelezionati.push(this.nodoCliccato);
    this.cy.center(this.cy.getElementById(this.nodoCliccato));
    this.cy.zoom({
      level: 1,
      position: this.cy.getElementById(this.nodoCliccato).position()
    });
    this.cy.getElementById(this.nodoCliccato).flashClass('highlightOpen', 1000);
  }

  // relazione di default all'apertura della pagina è iponimia
  // resetto valore focusnode
  ngAfterViewInit() {
    this.iponimia();
    window.sessionStorage.removeItem('focusNode');
  }

// metodo che gestisce i radio button delle relazioni
  onHandleRelazioni(e: string) {
    if (e == 'iponimia') {
      this.iponimia();
    } else if (e == 'meronimia') {
      this.meronimia();
    } else if (e == 'sinonimia') {
      this.sinonimia();
    }
  }

  iponimia() {
    sessionStorage.getItem('focusNode');
    const that = this;
    this.relazioneIponimia = true;
    this.relazioneMeronimia = false;
    this.relazioneSinonimia = false;
    var elemMeronimia = this.cy.elements(':visible').filter('edge[relationType = "partMeronym"]');
    var elemSinonimia = this.cy.elements(':visible').filter('edge[relationType = "synonym"]');
    var elemIponimia = this.cy.elements(':visible').filter('edge[relationType = "hyponym"]');
    var elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    console.log(' IPONIMIA session storage ' + sessionStorage.getItem('focusNode'));
    // nodi da nascondere
    elemMeronimia.sources().style("visibility", "hidden");
    elemMeronimia.targets().style("visibility", "hidden");
    elemMeronimia.style("visibility", "hidden");
    elemSinonimia.sources().style("visibility", "hidden");
    elemSinonimia.targets().style("visibility", "hidden");
    elemSinonimia.style("visibility", "hidden");

    elemSessionStorage.removeClass("meronimia");
    elemSessionStorage.removeClass("meronimiaDBClick");
    elemSessionStorage.removeClass("sinonimia");
    elemSessionStorage.removeClass("sinonimiaDBClick");

    elemSessionStorage.outgoers().targets().removeClass("meronimia");
    elemSessionStorage.incomers().sources().removeClass("meronimia");
    elemSessionStorage.outgoers().targets().removeClass("sinonimia");
    elemSessionStorage.incomers().sources().removeClass("sinonimia");

    elemIponimia.sources().removeClass("meronimia");
    elemIponimia.targets().removeClass("meronimia");
    elemIponimia.sources().removeClass("meronimiaDBClick");
    elemIponimia.targets().removeClass("meronimiaDBClick");
    elemIponimia.sources().removeClass("sinonimia");
    elemIponimia.targets().removeClass("sinonimia");
    elemIponimia.sources().removeClass("sinonimiaDBClick");
    elemIponimia.targets().removeClass("sinonimiaDBClick");
    // nodo doppio clic /focus node
    elemSessionStorage.style("visibility", "visible");
    elemSessionStorage.removeClass('meronimiaDBClick');
    elemSessionStorage.addClass('iponimiaDBClick');
    elemSessionStorage.outgoers().targets().addClass("iponimia");
    elemSessionStorage.incomers().sources().addClass("iponimia");
    // nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().style("visibility", "visible");
    // stile nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().addClass("iponimia");
    elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().addClass("iponimia");
    // edges di iponimia
    elemSessionStorage.incomers('edge[relationType = "hyponym"]').style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "hyponym"]').style("visibility", "visible");
    // stile edges
    this.cy.elements('edge[relationType = "hyponym"]').addClass("edges");
    // POSIZIONI NODI PRE FUNZIONE DB CLIC
    if ((elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200
      || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200)) {
      // layout iponimi
      var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      iponimiIncomers.run();
      iponimiOutgoers.run();
      that.cy.fit(':visible');
    } else if (elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
      var iponimiIncomers = elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var iponimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      iponimiIncomers.run();
      iponimiOutgoers.run();
      that.cy.fit(':visible');
    } else {
      // nodi < 20
      // IPONIMIA
      elemSessionStorage.incomers('edge[relationType = "hyponym"]').sources().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc + 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      elemSessionStorage.outgoers('edge[relationType = "hyponym"]').targets().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc - 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      // that.cy.fit(':visible');
    }

    // evento doppio click con ricerca per iponimia
    this.cy.on('dblclick', 'node', function (event) {
      // recupero valore nodo cliccato e lo salvo nel local storage(memoria locale)
      sessionStorage.setItem('focusNode', event.target.data().id);
      let iponimiincomers = event.target.incomers('edge[relationType = "hyponym"]');
      let iponimioutgoers = event.target.outgoers('edge[relationType = "hyponym"]');
      let nodoDBClick = event.target;
      // localStorage.getItem('focusNode') ;
      iponimiincomers.style("visibility", "visible");
      iponimiincomers.sources().style("visibility", "visible");
      iponimioutgoers.style("visibility", "visible");
      iponimioutgoers.targets().style("visibility", "visible");

      iponimiincomers.sources().addClass("iponimia");
      iponimioutgoers.targets().addClass("iponimia");
      iponimiincomers.sources().removeClass("iponimiaDBClick");
      iponimioutgoers.targets().removeClass("iponimiaDBClick");
      iponimiincomers.addClass("edges");
      iponimioutgoers.addClass("edges");
      if (nodoDBClick) {
        nodoDBClick.addClass("iponimiaDBClick");
        nodoDBClick.removeClass("iponimia");
        nodoDBClick.removeClass("meronimiaDBClick");
        nodoDBClick.removeClass("sinonimiaDBClick");
      } else {
        nodoDBClick.removeClass("iponimiaDBClick");
      }

      let meronimiincomers = event.target.incomers('edge[relationType = "partMeronym"]');
      let meronimioutgoers = event.target.outgoers('edge[relationType = "partMeronym"]');
      meronimiincomers.style("visibility", "hidden");
      meronimioutgoers.style("visibility", "hidden");
      meronimiincomers.sources().style("visibility", "hidden");
      meronimioutgoers.targets().style("visibility", "hidden");

      let sinonimoincomers = event.target.incomers('edge[relationType = "synonym"]');
      let sinonimooutgoers = event.target.outgoers('edge[relationType = "synonym"]');
      sinonimoincomers.style("visibility", "hidden");
      sinonimooutgoers.style("visibility", "hidden");
      sinonimoincomers.sources().style("visibility", "hidden");
      sinonimooutgoers.targets().style("visibility", "hidden");

      if ((iponimiincomers.toArray().length > 20 && iponimiincomers.toArray().length < 200
        || iponimioutgoers.toArray().length > 20 && iponimioutgoers.toArray().length < 200)) {
        console.log("IPONIMIA DOPO DOUBLE CLIC nodi tra 20 e 200");
        // layout iponimi
        var iponimiIncomers = iponimiincomers.sources().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        var iponimiOutgoers = iponimioutgoers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        iponimiIncomers.run();
        iponimiOutgoers.run();
        that.cy.fit(':visible');
      } else if (iponimiincomers.toArray().length > 200 || iponimioutgoers.toArray().length > 200) {
        console.log("IPONIMIA DOPO DOUBLE CLIC nodi > 200");
        // layout iponimi
        var iponimiIncomers = iponimiincomers.sources().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
            h: 200, w: 200
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        var iponimiOutgoers = iponimioutgoers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
            h: 200, w: 100
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        iponimiIncomers.run();
        iponimiOutgoers.run();
        that.cy.fit(':visible');
        // posizionamento nodi nel caso di quantità inferiore a 20
      } else {
        console.log("IPONIMIA DOPO DOUBLE CLIC nodi < 20");
        // posizioni nodo cliccato, nodi entranti, nodi uscenti
        // IPONIMIA
        iponimiincomers.sources().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc + 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        iponimioutgoers.targets().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc - 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        // that.cy.fit(':visible');
      }
    });
  }

  meronimia() {
    sessionStorage.getItem('focusNode');
    const that = this;
    this.relazioneMeronimia = true;
    this.relazioneIponimia = false;
    this.relazioneSinonimia = false;

    var elemSinonimia = this.cy.elements(':visible').filter('edge[relationType = "synonym"]');
    var elemIponimia = this.cy.elements(':visible').filter('edge[relationType = "hyponym"]');
    var elemMeronimia = this.cy.elements(':visible').filter('edge[relationType = "partMeronym"]');

    var elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    console.log(' MERONIMIA session storage ' + sessionStorage.getItem('focusNode'));
    // nodi da nascondere
    elemIponimia.sources().style("visibility", "hidden");
    elemIponimia.targets().style("visibility", "hidden");
    elemIponimia.style("visibility", "hidden");
    elemSinonimia.sources().style("visibility", "hidden");
    elemSinonimia.targets().style("visibility", "hidden");
    elemSinonimia.style("visibility", "hidden");
    // nodo doppio clic /focus node
    elemSessionStorage.style("visibility", "visible");
    elemSessionStorage.removeClass("iponimia");
    elemSessionStorage.removeClass("iponimiaDBClick");
    elemSessionStorage.removeClass("sinonimia");
    elemSessionStorage.removeClass("sinonimiaDBClick");
    elemSessionStorage.outgoers().targets().removeClass("iponimia");
    elemSessionStorage.incomers().sources().removeClass("iponimia");
    elemSessionStorage.outgoers().targets().removeClass("sinonimia");
    elemSessionStorage.incomers().sources().removeClass("sinonimia");
    elemSessionStorage.addClass('meronimiaDBClick');
    elemSessionStorage.outgoers().targets().addClass("meronimia");
    elemSessionStorage.incomers().sources().addClass("meronimia");
    // nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().style("visibility", "visible");
    // stile nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().addClass("meronimia");
    elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().addClass("meronimia");
    // edges di iponimia
    elemSessionStorage.incomers('edge[relationType = "partMeronym"]').style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').style("visibility", "visible");
    // stile edges
    this.cy.elements('edge[relationType = "partMeronym"]').addClass("edges");
    elemMeronimia.sources().removeClass("iponimia");
    elemMeronimia.targets().removeClass("iponimia");
    elemMeronimia.sources().removeClass("iponimiaDBClick");
    elemMeronimia.targets().removeClass("iponimiaDBClick");
    elemMeronimia.sources().removeClass("sinonimia");
    elemMeronimia.targets().removeClass("sinonimia");
    elemMeronimia.sources().removeClass("sinonimiaDBClick");
    elemMeronimia.targets().removeClass("sinonimiaDBClick");

    // POSIZIONI NODI PRE FUNZIONE DB CLIC
    if ((elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "partMeronym"]').toArray().length < 200
      || elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').toArray().length < 200)) {
      console.log("IPONIMIA PRE DOUBLE CLIC nodi tra 20 e 200");
      // layout iponimi
      var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      meronimiIncomers.run();
      meronimiOutgoers.run();
      that.cy.fit(':visible');
    } else if (elemMeronimia.incomers().toArray().length > 200 || elemMeronimia.outgoers().toArray().length > 200) {
      console.log("MERONIMIA PRE DOUBLE CLIC nodi > 200");
      // layout iponimi
      var meronimiIncomers = elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var meronimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      meronimiIncomers.run();
      meronimiOutgoers.run();
      that.cy.fit(':visible');
      // posizionamento nodi nel caso di quantità inferiore a 20
    } else if (elemMeronimia.incomers().toArray().length < 20 || elemMeronimia.outgoers().toArray().length < 20) {
      console.log("MERONIMIA PRE DOUBLE CLIC nodi < 20");
      // posizioni nodo cliccato, nodi entranti, nodi uscenti
      // MERONIMIA
      elemSessionStorage.incomers('edge[relationType = "partMeronym"]').sources().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc + 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      elemSessionStorage.outgoers('edge[relationType = "partMeronym"]').targets().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc - 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      // that.cy.fit(':visible');
    }

    this.cy.on('dblclick', 'node', function (event) {
      // recupero valore nodo cliccato e lo salvo nel local storage(memoria locale)
      sessionStorage.setItem('focusNode', event.target.data().id);
      let meronimiincomers = event.target.incomers('edge[relationType = "partMeronym"]');
      let meronimioutgoers = event.target.outgoers('edge[relationType = "partMeronym"]');
      let nodoDBClick = event.target;

      // localStorage.getItem('focusNode');
      meronimiincomers.style("visibility", "visible");
      meronimiincomers.sources().style("visibility", "visible");
      meronimioutgoers.style("visibility", "visible");
      meronimioutgoers.targets().style("visibility", "visible");

      meronimiincomers.sources().addClass("meronimia");
      meronimioutgoers.targets().addClass("meronimia");
      meronimiincomers.sources().removeClass("meronimiaDBClick");
      meronimioutgoers.targets().removeClass("meronimiaDBClick");
      meronimiincomers.addClass("edges");
      meronimioutgoers.addClass("edges");

      if (nodoDBClick) {
        nodoDBClick.addClass("meronimiaDBClick");
        nodoDBClick.removeClass("meronimia");
        nodoDBClick.removeClass("iponimiaDBClick");
        nodoDBClick.removeClass("sinonimiaDBClick");
      } else {
        nodoDBClick.removeClass("meronimiaDBClick");
      }

      let iponimiincomers = event.target.incomers('edge[relationType = "hyponym"]');
      let iponimioutgoers = event.target.outgoers('edge[relationType = "hyponym"]');
      iponimiincomers.style("visibility", "hidden");
      iponimiincomers.sources().style("visibility", "hidden");
      iponimioutgoers.style("visibility", "hidden");
      iponimioutgoers.targets().style("visibility", "hidden");

      let sinonimoincomers = event.target.incomers('edge[relationType = "synonym"]');
      let sinonimooutgoers = event.target.outgoers('edge[relationType = "synonym"]');

      sinonimoincomers.style("visibility", "hidden");
      sinonimooutgoers.style("visibility", "hidden");
      sinonimoincomers.sources().style("visibility", "hidden");
      sinonimooutgoers.targets().style("visibility", "hidden");

      if ((meronimiincomers.toArray().length > 20 && meronimiincomers.toArray().length < 200
        || meronimioutgoers.toArray().length > 20 && meronimioutgoers.toArray().length < 200)) {
          // nodi tra 20 e 200
        var meronimiIncomers = meronimiincomers.sources().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        var meronimiOutgoers = meronimioutgoers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        meronimiIncomers.run();
        meronimiOutgoers.run();
        that.cy.fit(':visible');
      } else if (meronimiincomers.toArray().length > 200 || meronimioutgoers.toArray().length > 200) {
        // nodi > 200
        var meronimiIncomers = meronimiincomers.sources().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
            h: 200, w: 200
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        var meronimiOutgoers = meronimioutgoers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
            h: 200, w: 100
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        meronimiIncomers.run();
        meronimiOutgoers.run();
        that.cy.fit(':visible');
      } else {
        // nodi < 20
        meronimiincomers.sources().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc + 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        meronimioutgoers.targets().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc - 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        // that.cy.fit(':visible');
      }
    });
  }

  sinonimia() {
    sessionStorage.getItem('focusNode');
    const that = this;
    this.relazioneSinonimia = true;
    this.relazioneIponimia = false;
    this.relazioneMeronimia = false;

    var elemIponimia = this.cy.elements(':visible').filter('edge[relationType = "hyponym"]');
    var elemMeronimia = this.cy.elements(':visible').filter('edge[relationType = "partMeronym"]');
    var elemSinonimia = this.cy.elements().filter('edge[relationType = "synonym"]');

    var elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    console.log('SINONIMI session storage ' + sessionStorage.getItem('focusNode'));
    // nodi da nascondere
    elemMeronimia.sources().style("visibility", "hidden");
    elemMeronimia.targets().style("visibility", "hidden");
    elemMeronimia.style("visibility", "hidden");
    elemIponimia.sources().style("visibility", "hidden");
    elemIponimia.targets().style("visibility", "hidden");
    elemIponimia.style("visibility", "hidden");

    // nodo doppio clic /focus node
    elemSessionStorage.style("visibility", "visible");
    elemSessionStorage.removeClass("meronimia");
    elemSessionStorage.removeClass("meronimiaDBClick");
    elemSessionStorage.removeClass("iponimia");
    elemSessionStorage.removeClass("iponimiaDBClick");
    elemSessionStorage.outgoers().targets().removeClass("iponimia");
    elemSessionStorage.incomers().sources().removeClass("iponimia");
    elemSessionStorage.outgoers().targets().removeClass("meronimia");
    elemSessionStorage.incomers().sources().removeClass("meronimia");
    elemSessionStorage.outgoers().targets().addClass("sinonimia");
    elemSessionStorage.incomers().sources().addClass("sinonimia");
    elemSessionStorage.addClass('sinonimiaDBClick');
    // nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().style("visibility", "visible");
    // stile nodi entranti e uscenti
    elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().addClass("sinonimia");
    elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().addClass("sinonimia");
    // edges di sinonimia
    elemSessionStorage.incomers('edge[relationType = "synonym"]').style("visibility", "visible");
    elemSessionStorage.outgoers('edge[relationType = "synonym"]').style("visibility", "visible");
    // stile edges
    elemSinonimia.addClass("edges");

    // tolgo freccia negli edge della sinonimia
    elemSinonimia.style("target-arrow-shape", 'none');
    elemSinonimia.style("source-arrow-shape", 'none');

    elemSinonimia.sources().removeClass("meronimia");
    elemSinonimia.targets().removeClass("meronimia");
    elemSinonimia.sources().removeClass("meronimiaDBClick");
    elemSinonimia.targets().removeClass("meronimiaDBClick");
    elemSinonimia.sources().removeClass("iponimia");
    elemSinonimia.targets().removeClass("iponimia");
    elemSinonimia.sources().removeClass("iponimiaDBClick");
    elemSinonimia.targets().removeClass("iponimiaDBClick");

    // POSIZIONI NODI PRE FUNZIONE DB CLIC
    if ((elemSessionStorage.incomers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.incomers('edge[relationType = "hyponym"]').toArray().length < 200
      || elemSessionStorage.outgoers('edge[relationType = "synonym"]').toArray().length > 20 && elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length < 200)) {
      // nodi tra 20 e 200
      var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 500, y1: elemSessionStorage.position("y") + 100,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      var sinonimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 50, y1: elemSessionStorage.position("y") - 150,
          h: 50, w: 50
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
      });
      sinonimiIncomers.run();
      sinonimiOutgoers.run();
      that.cy.fit(':visible');
    } else if (elemSessionStorage.incomers('edge[relationType = "synonym"]').toArray().length > 200 || elemSessionStorage.outgoers('edge[relationType = "hyponym"]').toArray().length > 200) {
      // nodi > 200
      var sinonimiIncomers = elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 1000, y1: elemSessionStorage.position("y") + 200,
          h: 200, w: 200
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      var sinonimiOutgoers = elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().layout({
        name: "grid", fit: true, boundingBox: {
          x1: elemSessionStorage.position('x') - 45, y1: elemSessionStorage.position("y") - 200,
          h: 200, w: 100
        }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
      });
      sinonimiIncomers.run();
      sinonimiOutgoers.run();
      that.cy.fit(':visible');
    } else {
      // nodi < 20
      elemSessionStorage.incomers('edge[relationType = "synonym"]').sources().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc + 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      elemSessionStorage.outgoers('edge[relationType = "synonym"]').targets().positions(function (nodi, i) {
        var xc = elemSessionStorage.position('x');
        var yc = elemSessionStorage.position('y');
        var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
        var yRet = yc - 75;
        return {
          x: xRet,
          y: yRet
        };
      });
      // that.cy.fit(':visible');
    }
    // funzione db clic
    this.cy.on('dblclick', 'node', function (event) {
      // recupero valore nodo cliccato e lo salvo nel local storage(memoria locale)
      sessionStorage.setItem('focusNode', event.target.data().id);
      let sinonimoincomers = event.target.incomers('edge[relationType = "synonym"]');
      let sinonimooutgoers = event.target.outgoers('edge[relationType = "synonym"]');
      let nodoDBClick = event.target;

      sinonimoincomers.style("visibility", "visible");
      sinonimooutgoers.style("visibility", "visible");
      sinonimoincomers.sources().style("visibility", "visible");
      sinonimooutgoers.targets().style("visibility", "visible");

      sinonimoincomers.sources().addClass("sinonimia");
      sinonimooutgoers.targets().addClass("sinonimia");
      sinonimoincomers.sources().removeClass("sinonimiaDBClick");
      sinonimooutgoers.targets().removeClass("sinonimiaDBClick");
      sinonimoincomers.addClass("edges");
      sinonimooutgoers.addClass("edges");
      // tolgo freccia negli edge della sinonimia
      sinonimoincomers.style("target-arrow-shape", 'none');
      sinonimooutgoers.style("target-arrow-shape", 'none');

      if (nodoDBClick) {
        nodoDBClick.addClass("sinonimiaDBClick");
        nodoDBClick.removeClass("sinonimia");
        nodoDBClick.removeClass("iponimiaDBClick");
        nodoDBClick.removeClass("meronimiaDBClick");
      } else {
        nodoDBClick.removeClass("sinonimiaDBClick");
      }

      let iponimiincomers = event.target.incomers('edge[relationType = "hyponym"]');
      let iponimioutgoers = event.target.outgoers('edge[relationType = "hyponym"]');
      iponimiincomers.style("visibility", "hidden");
      iponimiincomers.sources().style("visibility", "hidden");
      iponimioutgoers.style("visibility", "hidden");
      iponimioutgoers.targets().style("visibility", "hidden");

      let meronimiincomers = event.target.incomers('edge[relationType = "partMeronym"]');
      let meronimioutgoers = event.target.outgoers('edge[relationType = "partMeronym"]');
      meronimiincomers.style("visibility", "hidden");
      meronimiincomers.sources().style("visibility", "hidden");
      meronimioutgoers.style("visibility", "hidden");
      meronimioutgoers.targets().style("visibility", "hidden");

      if ((sinonimoincomers.toArray().length > 20 && sinonimoincomers.toArray().length < 200
        || sinonimooutgoers.toArray().length > 20 && sinonimoincomers.toArray().length < 200)) {
        // nodi tra 20 e 200
        var sinonimiIncomers = sinonimoincomers.sources().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        var sinonimiOutgoers = sinonimoincomers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        sinonimiIncomers.run();
        sinonimiOutgoers.run();
        that.cy.fit(':visible');
      } else if (sinonimoincomers.toArray().length > 200 || sinonimooutgoers.toArray().length > 200) {
        // nodi > 200
        var sinonimiIncomers = sinonimoincomers.sources()().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
            h: 200, w: 200
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        var sinonimiOutgoers = sinonimoincomers.targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
            h: 200, w: 100
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        sinonimiIncomers.run();
        sinonimiOutgoers.run();
        that.cy.fit(':visible');
      } else {
        // nodi < 20
        sinonimoincomers.sources().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc + 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        sinonimooutgoers.targets().positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc - 75;
          return {
            x: xRet,
            y: yRet
          };
        });
        // that.cy.fit(':visible');
      }
    });
  }

  centrare(): void {
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.fit(elementiVisibili);
    this.cy.center(elementiVisibili);
  }

  openDivInfo() {
    const panel = document.getElementById('pannello');
    panel.style.display = 'none';
    this.isDisplay = true;
  }

  zoomReset(): void {
    this.cy.zoom(0.5);
    this.cy.center();
  }

  zoomIn(): void {
    if (this.zoomCurrent < this.cy.maxZoom()) {
      this.zoomCurrent += this.zoomStep;
      var elementiVisibili = this.cy.elements(':visible');
      this.cy.center(elementiVisibili);
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: elementiVisibili.position('x'), y: elementiVisibili.position('y') }
      });
    }
  }

  zoomOut(): void {
    if (this.zoomCurrent > this.cy.minZoom()) {
      this.zoomCurrent -= this.zoomStep;
      var elementiVisibili = this.cy.elements(':visible');
      this.cy.center(elementiVisibili);
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: elementiVisibili.position('x'), y: elementiVisibili.position('y') }
      });
    }
  }

  resetZoom(): void {
    this.cy.reset();
  }

  refreshPagina(): void {
    this.clicked = !this.clicked;
    this.removedData = this.cy.elements(':visible').style("display", "none");
    // svuoto local storage
    sessionStorage.removeItem('focusNode');
    this.searchText = ''  //svuoto input search
  }
}


